const files = require.context(".", false, /\.js$/);
let modules = {};

files.keys().forEach(key => {
  if (key === "./index.js") return;
  let defaultExport = files(key).default;
  modules[key.replace(/(\.\/|\.js)/g, "")] = defaultExport;
});

export default modules;
